import {uMobileConfig} from "@/config";

export function buildSubscribeFields(brandConfig, requestId, callbackUrl) {
    return {
        countryCode: brandConfig.countryCode,
        siteCode: brandConfig.siteCode,
        productName: brandConfig.productName,
        price: brandConfig.subscribePrice,
        currencyCode: brandConfig.currencyCode,
        callbackUrl: callbackUrl || uMobileConfig.returnUrl,
        mpaySubmit: 'Subscribe',
        requestId,
    };
}

export function submitUmobileSubscribe(fields, action = uMobileConfig.subscribeUrl) {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = action;
    form.style.display = 'none';

    Object.entries(fields).forEach(([name, value]) => {
        if (value === undefined || value === null || value === '') return;
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = String(value);
        form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
}
